import {
	graphql,
	usePreloadedQuery,
	type GraphQLTaggedNode,
	type PreloadedQuery,
} from 'react-relay';
import type {
	settingsSidebarPermissionQuery as SettingsSidebarPermissionQuery,
	settingsSidebarPermissionQuery$data,
} from './__generated__/settingsSidebarPermissionQuery.graphql';

export const settingsSidebarPermissionQuery: GraphQLTaggedNode = graphql`
	query settingsSidebarPermissionQuery($cloudId: ID!) {
		jira {
			# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
			...PageSwitcherWithQuery_jira
			# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
			...SidebarHeading_jira
		}
	}
`;

export const useSettingsSidebarPermissionRef = (
	queryReference: PreloadedQuery<SettingsSidebarPermissionQuery>,
): settingsSidebarPermissionQuery$data['jira'] =>
	usePreloadedQuery<SettingsSidebarPermissionQuery>(settingsSidebarPermissionQuery, queryReference)
		.jira;
